import { IAttachmentRequest } from "@/models/attachment-request.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";

export class SharingLinkFactory {
  sharedContent: ISharedContent | IAttachmentRequest;
  isEdit: boolean;
  queryParams?: Record<string, string | number>;

  constructor(
    sharedContent: ISharedContent | IAttachmentRequest,
    isEdit: boolean,
    queryParams?: Record<string, string | number>
  ) {
    this.sharedContent = sharedContent;
    this.isEdit = isEdit;
    this.queryParams = queryParams;
  }

  /**
   * Creates the url to the report and appends the specified query params
   */
  get createUrlWithQuery() {
    let url: string;

    if (!this.isEdit) {
      if (PartnerModule.partner.settings?.defaultUrl) {
        url = `https://${PartnerModule.partner.settings?.defaultUrl}/#/s/${this.sharedContent.token}`;
      } else {
        url = `${ConfigModule.portalUrl}/partners/${this.sharedContent.partnerId}/shared/${this.sharedContent.id}/access/${this.sharedContent.token}`;
      }
    } else {
      url = `https://${PartnerModule.partner.settings?.defaultUrl}/#/r/${this.sharedContent.token}`;
    }

    if (this.queryParams && Object.keys(this.queryParams).length) {
      const qs = new URLSearchParams(Object.entries(this.queryParams).map(([k, v]) => [k, String(v)])).toString();
      url += `?${qs}`;
    }
    return url;
  }

  copyLinkToClipboard() {
    navigator.clipboard.writeText(this.createUrlWithQuery);
  }
}
